import React from "react";
import { Grid, TextField } from "@mui/material";
import { Field, FieldProps } from "formik";
import OrderedList from "./OrderedList";

interface Props<T> {
  namespace: string;
  entries: T[];
  onAdd?: () => void;
  onDelete?: (index: number) => void;
}

const KeyValueEditor = <T extends object>({
  namespace,
  entries,
  onAdd,
  onDelete,
}: Props<T>) => {
  return (
    <OrderedList
      items={entries}
      itemComponent={(entry, index) => {
        const entryNamespace = `${namespace}[${index}]`;
        return (
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Field name={`${entryNamespace}.Text`}>
                {({ field, meta }: FieldProps) => (
                  <TextField
                    type="number"
                    {...field}
                    label="Key"
                    fullWidth
                    error={meta.error != null}
                    helperText={meta.touched ? meta.error : ""}
                  />
                )}
              </Field>
            </Grid>
            <Grid item xs={6}>
              <Field name={`${entryNamespace}.Value`}>
                {({ field, meta }: FieldProps) => (
                  <TextField
                    type="number"
                    {...field}
                    label="Value"
                    fullWidth
                    error={meta.error != null}
                    helperText={meta.touched ? meta.error : ""}
                  />
                )}
              </Field>
            </Grid>
          </Grid>
        );
      }}
      onAdd={onAdd}
      onDelete={onDelete}
    />
  );
};

export default KeyValueEditor;
